import { render, staticRenderFns } from "./TwilioSyncStore.vue?vue&type=template&id=2d2b61f6&scoped=true&"
import script from "./TwilioSyncStore.vue?vue&type=script&lang=js&"
export * from "./TwilioSyncStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b61f6",
  null
  
)

export default component.exports